import { render, staticRenderFns } from "./Delete-New-Request.vue?vue&type=template&id=499adff2&scoped=true&"
import script from "./Delete-New-Request.vue?vue&type=script&lang=js&"
export * from "./Delete-New-Request.vue?vue&type=script&lang=js&"
import style0 from "./Delete-New-Request.vue?vue&type=style&index=0&id=499adff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499adff2",
  null
  
)

export default component.exports